var map = {
	"./bonusShopIcon.svg": 766,
	"./fortuneIcon.svg": 767,
	"./fortuneIconL.svg": 768,
	"./helpdeskIcon.svg": 769,
	"./helpdeskIconL.svg": 770,
	"./homeIcon.svg": 771,
	"./homeIconLarge.svg": 772,
	"./jackpotIcon.svg": 773,
	"./logo.svg": 774,
	"./logoSmall.svg": 775,
	"./lotteryIcon.svg": 776,
	"./loyaltyIcon.svg": 777,
	"./mobileAppIcon.svg": 778,
	"./profileIcon.svg": 779,
	"./questIcon.svg": 780,
	"./questsIcon.svg": 781,
	"./rewardLineupIcon.svg": 782,
	"./searchIcon.svg": 783,
	"./searchIconLarge.svg": 784,
	"./signOutIcon.svg": 785,
	"./star.svg": 786,
	"./tournamentIcon.svg": 787,
	"./tournamentLargeIcon.svg": 788,
	"./vipIcon.svg": 789,
	"./wheelIcon.svg": 790,
	"./wheelIconL.svg": 791,
	"./wheelIconMobile.svg": 792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 765;